export default __webpack_public_path__ + "static/media/screenshot.f4a0a446.jpg";